import { get } from 'lodash';

import { MODULE_REDUCER_KEY } from 'constants/reducer';

import { REDUCER_KEY } from '../constants';
import { UserAdminState } from '../types';

export default (state): UserAdminState =>
  get(state, [MODULE_REDUCER_KEY, REDUCER_KEY]);
